import * as io from 'socket.io-client';
import { createMockSocket } from './mockSocket';
import { getEmbedToken } from './embedMode';

// Same expression used by the pre-extraction SourcesContext.tsx (SOCKET_URL).
const SOCKET_URL = `${process.env.REACT_APP_API_URL || ""}`;

/**
 * Creates the Socket.IO client used by SourcesContext.
 *
 * When REACT_APP_E2E=true (set by e2e/playwright.config.ts's webServer env),
 * this returns an in-memory mock socket instead of connecting to a real
 * backend, so Playwright tests can run against the CRA dev server with zero
 * DB/backend dependency. In all other cases (production and normal dev) this
 * is a pure extraction of the previous inline `io.connect(...)` call — same
 * URL, same options.
 */
export function createSocket(): SocketIOClient.Socket {
  if (process.env.REACT_APP_E2E === 'true') {
    return createMockSocket() as unknown as SocketIOClient.Socket;
  }

  // In embedded mode the session cookie is never sent (cross-domain iframe),
  // so the handshake carries the in-memory embed token instead — COM-636.
  const embedToken = getEmbedToken();

  return io.connect(SOCKET_URL, {
    transports: ['polling', 'websocket'],
    forceNew: true,
    reconnection: true,
    timeout: 5000,
    withCredentials: true,
    ...(embedToken ? { auth: { embedToken } } : {})
  } as any);
}
